var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5.89515 3.99943L8.75905 1.14179C9.02021 0.880587 9.02021 0.457099 8.75905 0.1959C8.49788 -0.0652999 8.07446 -0.0652999 7.81329 0.1959L4.95605 3.06021L2.09882 0.1959C1.83765 -0.0652999 1.41423 -0.0652999 1.15306 0.1959C0.891901 0.457099 0.891901 0.880587 1.15306 1.14179L4.01696 3.99943L1.15306 6.85708C1.02698 6.98215 0.956055 7.15241 0.956055 7.33002C0.956055 7.50763 1.02698 7.67789 1.15306 7.80296C1.27812 7.92907 1.44835 8 1.62594 8C1.80353 8 1.97376 7.92907 2.09882 7.80296L4.95605 4.93866L7.81329 7.80296C7.93835 7.92907 8.10858 8 8.28617 8C8.46376 8 8.63399 7.92907 8.75905 7.80296C8.88513 7.67789 8.95605 7.50763 8.95605 7.33002C8.95605 7.15241 8.88513 6.98215 8.75905 6.85708L5.89515 3.99943Z",
    fill: "#6D6D70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4eab34838a3d8c2892060068fd779a19.svg";
export { ForwardRef as ReactComponent };